import getRoutes from '@/lib/getRoutes'
import pushRoute from '@/lib/pushRoute'
import React from 'react'
import Image from 'next/image'
import COLORS from '@/src/colors'
import { Box, Grid, useTheme, ButtonGroup, Menu, MenuItem } from '@mui/material'
import MuiButton from '@mui/material/Button'
import FONTS from '@/src/fonts'
import { getDomainSetting } from '@/lib/getDomainSettings'
import Card from '../Common/Card'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Button from '@/components/Common/Button'
import AddToQueueIcon from '@mui/icons-material/AddToQueue'
import LoginIcon from '@mui/icons-material/Login'

const BlockInfos: React.FC = () => {
  const theme = useTheme()
  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null)
  const isMenuOpen = Boolean(menuAnchorEl)

  const urlVendor = getRoutes({ route: 'CreateVendor' })

  const handleMenuToggle = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(current => (current ? null : event.currentTarget))
  }

  const handleMenuClose = () => {
    setMenuAnchorEl(null)
  }

  return (
    <Card elevate>
      <Grid container spacing={4} sx={{}}>
        <Grid
          item
          xs={12}
          md={9}
          sx={{
            fontWeight: FONTS.WEIGHT.BOLD,
            fontSize: theme.typography.pxToRem(64),
            [theme.breakpoints.down('sm')]: {
              fontSize: '0.8rem',
            },
            whiteSpace: 'nowrap',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <span style={{ color: theme.palette.text.primary, paddingRight: 8 }}>
              Créé pour les{' '}
            </span>
            <span style={{ color: theme.palette.primary.main }}> Pharmaciens</span>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
          display={'flex'}
          justifyContent={'flex-end'}
          alignItems={'flex-start'}
        >
          <div>
            <ButtonGroup
              variant={'contained'}
              disableElevation
              sx={{
                borderRadius: 2,
                '& .MuiButton-root': {
                  backgroundColor: COLORS.thirty_v2,
                  color: theme.palette.text.primary,
                  borderColor: COLORS.thirty_v2,
                  textTransform: 'none',
                  fontSize: theme.typography.pxToRem(16),
                  fontWeight: 600,
                  paddingTop: 1,
                  paddingBottom: 1,
                  [theme.breakpoints.down('sm')]: {
                    fontSize: theme.typography.pxToRem(12),
                  },
                  '&:hover': {
                    backgroundColor: COLORS.thirty_v2,
                  },
                },
              }}
            >
              <MuiButton onClick={handleMenuToggle} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                <Image
                  src={'/images/icons/diamond.png'}
                  alt={'vendeur'}
                  width={20}
                  height={20}
                  style={{ marginRight: 8 }}
                />
                Vendre sur Pharmedistore
              </MuiButton>
              <MuiButton
                aria-haspopup={'menu'}
                aria-expanded={isMenuOpen ? 'true' : undefined}
                aria-controls={isMenuOpen ? 'vendor-menu' : undefined}
                onClick={handleMenuToggle}
                sx={{
                  minWidth: 48,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  paddingLeft: 1,
                  paddingRight: 1,
                }}
              >
                <ArrowDropDownIcon />
              </MuiButton>
            </ButtonGroup>
            <Menu
              id={'vendor-menu'}
              anchorEl={menuAnchorEl}
              open={isMenuOpen}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              <MenuItem
                onClick={async () => {
                  handleMenuClose()
                  return pushRoute(urlVendor)
                }}
              >
                <AddToQueueIcon className={'mr-3'} /> Ouvrir un nouveau compte vendeur
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleMenuClose()
                  window.location.href = getDomainSetting('vendorUrl')
                }}
              >
                <LoginIcon className={'mr-3'} />
                Me connecter à mon espace vendeur
              </MenuItem>
            </Menu>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          justifyContent={'center'}
          display={'flex'}
          alignContent={'center'}
        >
          <Button
            variant={'contained'}
            sx={{
              height: 60,
              borderRadius: 2,
              backgroundColor: theme.palette.text.primary,
              fontSize: theme.typography.pxToRem(16),
              [theme.breakpoints.down('md')]: {
                fontSize: '0.6rem',
                height: 40,
              },
              paddingRight: 4,
              paddingLeft: 4,
              whiteSpace: 'nowrap',
            }}
            onClick={() => {
              window.location.href = `${getDomainSetting(
                'urlExtranetGroup'
              )}inscription?type=pharmacy`
            }}
          >
            Je suis pharmacien. Je m’inscris gratuitement !
          </Button>
        </Grid>
        <Grid item xs={12} md={8} display={'flex'} alignContent={'center'}>
          <Box
            sx={{
              paddingLeft: 4,
              fontSize: theme.typography.pxToRem(20),
              color: theme.palette.text.primary,
              [theme.breakpoints.down('md')]: {
                fontSize: '0.8rem',
                textAlign: 'center',
              },
            }}
          >
            Tout ce que vous attendez d’une <b>centrale d’achat</b> et bien plus encore...
            <br />
            Une <b>offre complète</b> pour combler tous vos besoins.
          </Box>
        </Grid>

        <Grid item xs={12} md={12} justifyContent={'center'} display={'flex'}>
          <Image
            src={'/images/marques-home/block_info.png'}
            alt={'infos'}
            width={1415}
            height={169}
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </Grid>
        {/* <Grid item xs={12} md={12} justifyContent={'center'} display={'flex'}>
          <Grid container>
            <Grid item xs={0} md={3} />
            <Grid item xs={12} md={3} justifyContent={'center'} display={'flex'}>
              <Button
                sx={{
                  borderRadius: 2,
                  backgroundColor: theme.palette.background.default,
                  color: theme.palette.primary.main,
                  [theme.breakpoints.down('md')]: {
                    fontSize: '0.6rem',
                  },
                }}
                onClick={() => {
                  pushRoute(getRoutes({ route: 'OctLeader' }))
                }}
              >
                <Image
                  src={'/images/icons/trophy.png'}
                  alt={'vendeur'}
                  width={20}
                  height={20}
                  style={{ marginRight: 8 }}
                />
                Voir nos laboratoires leaders
              </Button>
            </Grid>
            <Grid item xs={12} md={3} justifyContent={'center'} display={'flex'}>
              <Button
                sx={{
                  borderRadius: 2,
                  backgroundColor: theme.palette.background.default,
                  color: theme.palette.primary.main,
                  [theme.breakpoints.down('md')]: {
                    fontSize: '0.6rem',
                  },
                }}
                onClick={() => {
                  pushRoute(getRoutes({ route: 'Promotions' }))
                }}
              >
                <Image
                  src={'/images/icons/discount_percent.png'}
                  alt={'vendeur'}
                  width={20}
                  height={20}
                  style={{ marginRight: 8 }}
                />
                Voir nos promotions
              </Button>
            </Grid>
            <Grid item xs={0} md={3} />
          </Grid>
        </Grid>*/}
      </Grid>
    </Card>
  )
}

export default BlockInfos
